import api from './api';

const unwrap = (response) => response?.data;

export const fetchApplicationRoleCatalog = async () =>
  unwrap(await api.get('/application-roles/catalog'));

export const fetchApplicationRoles = async (params = {}) =>
  unwrap(await api.get('/application-roles', { params }));

export const createApplicationRole = async (payload) =>
  unwrap(await api.post('/application-roles', payload));

export const updateApplicationRole = async (id, payload) =>
  unwrap(await api.put(`/application-roles/${encodeURIComponent(id)}`, payload));

export const deleteApplicationRole = async (id) =>
  unwrap(await api.delete(`/application-roles/${encodeURIComponent(id)}`));

export const fetchRoleOptions = async () =>
  unwrap(await api.get('/role-options'));

const applicationRolesApi = {
  fetchApplicationRoleCatalog,
  fetchApplicationRoles,
  createApplicationRole,
  updateApplicationRole,
  deleteApplicationRole,
  fetchRoleOptions,
};

export default applicationRolesApi;
